import { configureStore } from '@reduxjs/toolkit';
import questionReducer from './Slice'

const store = configureStore({
    reducer: {
        questions: questionReducer
    },
});
export default store;